module.exports = "/images/disclosure_status_sprite.png?ed1b1c144a0d530099131cf93ea37405";